export function getConfig() {
  const result: {
    PLATFORM_WS: string
    PLATFORM_URL: string
    PLATFORM_API: string
    COMPLIANCE_URL: string
    COMPLIANCE_WS: string
    COMPLIANCE_API: string
    MINERVA_URL: string
    MINERVA_API: string
    INTERNAL_URL: string
    INTERNAL_API: string
    GITHUB_URL: string
    TITLE: string
    DOCS_URL: string
    ENV: string
    VERSION: string
    AUTH_CLIENT_ID: string
    AUTH_AUDIENCE: string
    AUTH_URL: string
    APP_NAME: string
    WORKOS_AUTH_CLIENT_ID: string
    WORKOS_AUTH_URL: string
    AUTH_REDIRECT_URI: string
    WORKOS_DEV_MODE: string
    GLEAP_API_KEY: string
    POSTHOG_API_KEY: string
    POSTHOG_API_HOST: string
    template: (template: string) => string
  } = {
    PLATFORM_WS: '',
    PLATFORM_URL: '',
    PLATFORM_API: '',
    COMPLIANCE_URL: '',
    COMPLIANCE_WS: '',
    COMPLIANCE_API: '',
    MINERVA_URL: '',
    MINERVA_API: '',
    INTERNAL_URL: '',
    INTERNAL_API: '',
    GITHUB_URL: '',
    TITLE: process.env.TITLE ?? '',
    DOCS_URL: '',
    ENV: process.env.ENV ?? '',
    VERSION: '',
    AUTH_CLIENT_ID: '',
    AUTH_AUDIENCE: '',
    AUTH_URL: '',
    APP_NAME: process.env.APP_NAME ?? '',
    WORKOS_AUTH_CLIENT_ID: process.env.WORKOS_AUTH_CLIENT_ID ?? '',
    WORKOS_AUTH_URL: process.env.WORKOS_AUTH_URL ?? '',
    WORKOS_DEV_MODE: process.env.WORKOS_DEV_MODE ?? '',
    AUTH_REDIRECT_URI: '',
    GLEAP_API_KEY: '',
    POSTHOG_API_KEY: '',
    POSTHOG_API_HOST: '',
    template: function templateFromConfig(template: string) {
      return Object.keys(result).reduce(
        (compiled, key) => compiled.replaceAll(`%${key}%`, result[key] ?? ''),
        template
      )
    },
  }

  if (process.env.APP_NAME === 'platform') {
    result['PLATFORM_WS'] = process.env.PLATFORM_WS ?? ''
    result['PLATFORM_URL'] = process.env.PLATFORM_URL ?? ''
    result['PLATFORM_API'] = process.env.PLATFORM_API ?? ''
    result['DOCS_URL'] = process.env.DOCS_URL ?? ''
    result['VERSION'] = process.env.VERSION ?? ''
    result['GLEAP_API_KEY'] = process.env.GLEAP_API_KEY ?? ''
    result['POSTHOG_API_KEY'] = process.env.POSTHOG_API_KEY ?? ''
    result['POSTHOG_API_HOST'] = process.env.POSTHOG_API_HOST ?? ''
    result['AUTH_REDIRECT_URI'] = process.env.PLATFORM_URL ?? ''
  }

  if (process.env.APP_NAME === 'compliance') {
    result['COMPLIANCE_WS'] = process.env.COMPLIANCE_WS ?? ''
    result['COMPLIANCE_URL'] = process.env.COMPLIANCE_URL ?? ''
    result['COMPLIANCE_API'] = process.env.COMPLIANCE_API ?? ''
    result['PLATFORM_URL'] = process.env.PLATFORM_URL ?? ''
    result['AUTH_REDIRECT_URI'] = process.env.COMPLIANCE_URL ?? ''
  }

  if (process.env.APP_NAME === 'minerva') {
    result['MINERVA_URL'] = process.env.MINERVA_URL ?? ''
    result['MINERVA_API'] = process.env.MINERVA_API ?? ''
    result['AUTH_REDIRECT_URI'] = process.env.MINERVA_URL ?? ''
  }

  if (process.env.APP_NAME === 'internal') {
    result['INTERNAL_URL'] = process.env.INTERNAL_URL ?? ''
    result['GITHUB_URL'] = process.env.GITHUB_URL ?? ''
    result['PLATFORM_URL'] = process.env.PLATFORM_URL ?? ''
    result['INTERNAL_API'] = process.env.INTERNAL_API ?? ''
    result['DOCS_URL'] = process.env.DOCS_URL ?? ''
    result['AUTH_REDIRECT_URI'] = process.env.INTERNAL_URL ?? ''
  }

  if (process.env.APP_NAME === 'api-test') {
    result['PLATFORM_API'] = process.env.PLATFORM_API ?? ''
    result['PLATFORM_WS'] = process.env.PLATFORM_WS ?? ''
    result['COMPLIANCE_API'] = process.env.COMPLIANCE_API ?? ''
    result['COMPLIANCE_WS'] = process.env.COMPLIANCE_WS ?? ''
    result['INTERNAL_API'] = process.env.INTERNAL_API ?? ''
    result['MINERVA_API'] = process.env.MINERVA_API ?? ''
  }

  return result
}

export default function useConfig() {
  return getConfig()
}
